import React, { useState } from "react";
import { LocalizationProvider, StaticDatePicker} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import { Dayjs } from "dayjs";
import Button from "../Button";

const TimeSelect = ({handleTimeSelected}: {
  handleTimeSelected : () => void
}) => {
  const [value, setValue] = useState<Dayjs | null>(null);
  const date = value?.toDate().toString().split("").slice(0,16).join().replaceAll(",","")
  
  
  const allow = () => {
    if (date) {
      return false
    }else {
      return true
    }
  }
  return (
    <div className="bg-[rgba(255,_255,_255,_0.5)] [box-shadow:_0px_2px_25px_1px_rgba(1,_126,_145,_0.05)] h-[60vh] mt-5 p-5 flex relative">
      <div>
      <p className="text-lg text-main-blue">Schedule your Interview</p>
      <div className = "mt-3">
        <p>
          <span>Date: </span>
          <span>{date}</span>
        </p>
      </div>
      <div className="mt-10">
        <Button disabled = {allow()} onClick={handleTimeSelected}>
          Schedule
        </Button>
      </div>
      </div>
      <div className=" w-[50%] ml-[20%] mt-[-2%]">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DemoContainer components={["DesktopDateTimePicker"]}>
            <div className="">
            <DemoItem>
             <StaticDatePicker orientation= {"landscape"} value = {value} onChange={(newValue) => setValue(newValue)} />
            </DemoItem>
            </div>
          </DemoContainer>
        </LocalizationProvider>
      </div>
    </div>
  );
};

export default TimeSelect;
